
import React from "react";
import GoogleMapReact from "google-map-react";
import markerStart from "./../../assets/marker.svg";
import markerEnd from "./../../assets/lastMarker.svg";
import marker from "./../../assets/defaultMarkerImg.svg";
import MapWrapper from "./MapWrapper";

const markerDivStyleStart = {
  position: "absolute",
  backgroundImage: `url(${markerStart})`,
  backgroundRepeat: 'no-repeat',
  width: "50px",
  height: "55px",
  top: "100%",
  left: "50%",
  transform: "translate(-50%, -100%)"
};
const markerDivStyleEnd = {
  position: "absolute",
  backgroundImage: `url(${markerEnd})`,
  backgroundRepeat: 'no-repeat',
  width: "50px",
  height: "55px",
  top: "100%",
  left: "50%",
  transform: "translate(-50%, -100%)"
};
const markerDivStyle = {
  position: "absolute",
  backgroundImage: `url(${marker})`,
  backgroundRepeat: 'no-repeat',
  width: "50px",
  height: "55px",
  top: "100%",
  left: "50%",
  transform: "translate(-50%, -100%)"
};
const textStyle = {
  position: "absolute",
  alignItems: 'center',
  justifyContent:'center',
  textAlign:'center',
  top:"37%",
  left:"47%",
  transform: "translate(-50%, -50%)"
}
const textStyleStart = {
  position: "absolute",
  alignItems: 'center',
  justifyContent:'center',
  textAlign:'center',
  top:"40%",
  left:"51%",
  transform: "translate(-50%, -50%)"
}
const textStyleEnd = {
  position: "absolute",
  alignItems: 'center',
  justifyContent:'center',
  textAlign:'center',
  top:"40%",
  left:"52%",
  transform: "translate(-50%, -50%)"
}
const MAP = {
  defaultZoom: 14,
  defaultCenter: { lat: 28.595650, lng: 77.343940 },
  options: {
    maxZoom: 20,
  },
};
class SimpleMap extends React.Component {
  static defaultProps = {
    center: {
      lat: 28.595650,
      lng: 77.343940
    },
    zoom: 11
  };
  state = {
    directions: null,    
};
  render() {
    const apiIsLoaded = (map, maps) => {
      var rendererOptions = {
        map: map,
        preserveViewport: this.props.chartData.length===1?true:false,
        suppressMarkers : true,
        polylineOptions: {
          strokeColor: "#7CD6FF",
          strokeWeight: 4,
          strokeOpacity: 0.75,
        }
      }
      const directionsService = new maps.DirectionsService();
      const directionsRenderer = new maps.DirectionsRenderer(rendererOptions);
      directionsRenderer.setMap(map);
      var length=this.props.chartData.length;
      var waypoints=[];
      if(length>0){
        const origin = this.props.chartData[0];
        for (let i = 1; i < length; i++) {
          waypoints.push({location:{lat:this.props.chartData[i].lat,lng:this.props.chartData[i].lng}})
        }
        const destination = this.props.chartData[length-1];
        directionsService.route(
          {
            origin: origin,
            destination: destination,
            waypoints: waypoints,
            travelMode: maps.TravelMode.DRIVING
          },
          (result, status) => {
            if (status === maps.DirectionsStatus.OK) {
              this.setState({
                directions: result
            });
              directionsRenderer.setDirections(result);
            } else {
              console.error(`error fetching directions ${result}`);
            }
          }
        );
      }
    };
    return (
      <MapWrapper>
        <GoogleMapReact
          bootstrapURLKeys={{
            key: process.env.REACT_APP_GOOGLE_API_KEY
          }}
          defaultCenter={this.props.chartData[0]?this.props.chartData[0]:MAP.defaultCenter}
          defaultZoom={MAP.defaultZoom}
          yesIWantToUseGoogleMapApiInternals
          trackingData
          style={{ width: "100%", height: "608px" }}
          onGoogleApiLoaded={({ map, maps }) => apiIsLoaded(map, maps)}
        >
          {this.props.chartData.map((i, index) => {
            if (i.length !== 0) {
              if(i.id==1){
                return (                  
                  <div style={markerDivStyleStart} key={i.id} lat={i.lat} lng={i.lng} >
                    <div style={textStyleStart}>{i.id}</div>                     
                  </div>
                );
              }
              else if(i.id==(this.props.chartData.length)){
                return (                  
                  <div style={markerDivStyleEnd} key={i.id} lat={i.lat} lng={i.lng} >
                    <div style={textStyleEnd}>{i.id}</div>                     
                  </div>
                );
              }
              else{
                return (                  
                  <div style={markerDivStyle} key={i.id} lat={i.lat} lng={i.lng} >
                    <div style={textStyle}>{i.id}</div>                     
                  </div>
                );
              }
            }
          })}
        </GoogleMapReact>
      </MapWrapper>
    );
  }
}

export default SimpleMap;
